import React from "react";
import { Link } from "react-router-dom";
import "./DietyList.css";

const menuItems = [
    {
        id: 1,
        title: "Sree Padmanabha \n Swamy",
        action: "Book Now",
        image: "./images/image.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=1",
        external: true,
    },
    {
        id: 2,
        title: "Sree Narasimha \n Swamy",
        action: "View",
        image: "./images/narasimham.png",
         link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=2",
        external: true,
    },
    {
        id: 3,
        title: "Sree Krishna \n Swamy",
        action: "View",
        image: "./images/krishnan.png",
        link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=3",
        external: true,
    },
    {
        id: 4,
        title: "Sree Sastha",
        action: "View",
        image: "./images/ayyappa.jpg",
         link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=4",
        external: true,
    },
    {
        id: 5,
        title: "Sree \n Mahaganapathy",
        action: "Donate",
        image: "./images/ganapaty.webp",
         link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=5",
        external: true,
    },
    {
        id: 6,
        title: "Sree Hanuman \n Swamy",
        action: "View",
        image: "./images/hanuman.jpeg",
        link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=6",
        external: true,
    },
    {
        id: 7,
        title: "Veda Vyasar",
        action: "Book",
        image: "./images/vyasar.jpeg",
        link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=7",
        external: true,
    },
    {
        id: 8,
        title: "Sreerama \n Swamy",
        action: "View",
        image: "./images/rama.png",
         link: "https://booking.sreepadmanabhaswamytemple.org/Default.aspx?i=8",
        external: true,
    },
    // {
    //     id: 9,
    //     title: "E-Kanika",
    //     action: "View",
    //     image: "./images/kanik.png",
    //      link: "/",
    //     external: true,
    // },
];

function DietyList() {

    const renderMenuItem = (item) => {

        const content = (
            <article className="diety-card" >

                {/* Circular Image */}
                <div className="diety-image-wrapper" style={{display:'flex',flexDirection:'column'}}>

                    <div className="diety-image-circle" >

                        <img
                            src={item.image}
                            alt={item.title}
                        />
                             
                    </div>
                    <div className="dt">
                         {item.title}
                    </div>
                </div>

                {/* Title */}
               

                {/* Arrow */}
                {/* <div className="diety-arrow">
                    <i className="fa fa-angle-right"></i>
                </div> */}

            </article>
        );

        /* External Link */
        if (item.external) {
            return (
                <a
                    key={item.id}
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="diety-link"
                >
                    {content}
                </a>
            );
        }

        /* Internal React Route */
        return (
            <Link
                key={item.id}
                to={item.link}
                className="diety-link"
            >
                {content}
            </Link>
        );
    };

    return (
        <main className="diety-page">

            <div className="diety-container">

                {/* Heading */}
                {/* <div className="diety-heading">

                    <span className="diety-subtitle">
                        Sree Padmanabhaswamy Temple
                    </span>

                    <h1>
                        Temple Services
                    </h1>

                    <div className="diety-heading-line"></div>

                </div> */}

                {/* 9 Items */}
                <section
                    className="diety-grid"
                    aria-label="Temple Services"
                >

                    {menuItems.map(renderMenuItem)}

                </section>

            </div>

        </main>
    );
}

export default DietyList;